export const SEND_FEEDBACK = "SEND_FEEDBACK"
export const SEND_FEEDBACK_SUCCESS = "SEND_FEEDBACK_SUCCESS"
export const SEND_FEEDBACK_FAILURE = "SEND_FEEDBACK_FAILURE"